import React from 'react';
import CounterBox from '../../components/ConsultancyElements/CounterBox';
import SectionTitle from '../../components/ConsultancyElements/SectionTitle';
import BussinessAbout from './BussinessAbout';
import ServiceContainer from './ServiceContainer';

const BussinessSection = () => {

    return (
        <section className="business-section-three pb-0" style={{    marginTop: '40px'}}>
            {/* <div className="image-layer" style={{ backgroundImage: `url(images/background/19.jpg)` }}></div> */}
            <div className="container">
                <SectionTitle  title='Products/Solutions' header='Design and delivery of future-ready international K-12 curricula for primary-, middle- and high school academic programs aligned with global and local priorities as well as joint academic program delivery through partnering with us.' />

                <ServiceContainer />



                <BussinessAbout />
                <CounterBox />
            </div>
            <div className="image-layer-bottom" style={{ backgroundImage: `url(images/background/7.jpg)` }} ></div>
        </section>
    );
};

export default BussinessSection;